import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import { renewMyPassword as _renewMyPassword, getInfo as _getInfo, login as _login, logout as _logout, resetPassword as _resetPassword } from '@/api/user';
import { getAdminUsers } from '@/api/adminuser';
import adapi from '@/api/advertisementApi';
import { getToken, removeToken, setToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import axios from 'axios';
var state = {
  userId: '',
  token: getToken(),
  account: '',
  isSuperuser: null,
  name: '',
  avatar: '',
  introduction: '',
  callSystemAccount: '',
  roles: [],
  permissions: null,
  adminUsers: [] // 管理员用户
};
var mutations = {
  SET_ADMIN_USERS: function SET_ADMIN_USERS(state, users) {
    console.log('SET_ADMIN_USERS', users);
    state.adminUsers = _toConsumableArray(users);
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    axios.defaults.headers.common['token'] = token;
    state.token = token;
  },
  SET_USERID: function SET_USERID(state, userId) {
    axios.defaults.headers.common['userId'] = userId;
    state.userId = userId;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_ACCOUNT: function SET_ACCOUNT(state, account) {
    state.account = account;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  IS_SUPER_USER: function IS_SUPER_USER(state, val) {
    state.isSuperuser = val;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_CALL_SYSTEM_ACCOUNT: function SET_CALL_SYSTEM_ACCOUNT(state, callSystemAccount) {
    state.callSystemAccount = callSystemAccount;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permission) {
    state.permissions = permission;
  }
};
var actions = {
  // user login
  login: function () {
    var _login2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, userInfo) {
      var commit, account, password, code, temToken, _yield$_login, data, status, errCode, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            console.log('登录用户', userInfo);
            account = userInfo.account, password = userInfo.password, code = userInfo.code, temToken = userInfo.temToken;
            _context.prev = 3;
            _context.next = 6;
            return _login({
              account: account.trim(),
              password: password,
              loginCode: code,
              temToken: temToken
            });
          case 6:
            _yield$_login = _context.sent;
            data = _yield$_login.data;
            status = _yield$_login.status;
            errCode = _yield$_login.errCode;
            message = _yield$_login.message;
            if (!(status === '0')) {
              _context.next = 26;
              break;
            }
            if (!(errCode == 0)) {
              _context.next = 19;
              break;
            }
            commit('SET_TOKEN', data.token);
            commit('SET_USERID', data.id);
            setToken(data.token);
            return _context.abrupt("return", true);
          case 19:
            if (!(errCode === 2002 || errCode === 2004)) {
              _context.next = 23;
              break;
            }
            return _context.abrupt("return", Promise.reject({
              data: data,
              status: status,
              errCode: errCode,
              message: message
            }));
          case 23:
            return _context.abrupt("return", Promise.reject(message));
          case 24:
            _context.next = 31;
            break;
          case 26:
            if (!(errCode === 2005)) {
              _context.next = 30;
              break;
            }
            return _context.abrupt("return", Promise.reject({
              data: data,
              status: status,
              errCode: errCode,
              message: message
            }));
          case 30:
            return _context.abrupt("return", Promise.reject(message));
          case 31:
            _context.next = 36;
            break;
          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", Promise.reject(_context.t0));
          case 36:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 33]]);
    }));
    function login(_x, _x2) {
      return _login2.apply(this, arguments);
    }
    return login;
  }(),
  // user logout
  logout: function logout(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      _logout(state.token).then(function () {
        commit('SET_TOKEN', null);
        commit('SET_NAME', '');
        commit('SET_USERID', null);
        commit('SET_INTRODUCTION', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        removeToken();
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  //密码过期重置密码
  resetPassword: function () {
    var _resetPassword2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3, params) {
      var commit, dispatch, _yield$_resetPassword, data, status, errCode, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref3.commit, dispatch = _ref3.dispatch;
            _context2.prev = 1;
            _context2.next = 4;
            return _resetPassword(params);
          case 4:
            _yield$_resetPassword = _context2.sent;
            data = _yield$_resetPassword.data;
            status = _yield$_resetPassword.status;
            errCode = _yield$_resetPassword.errCode;
            message = _yield$_resetPassword.message;
            if (!(status === '0')) {
              _context2.next = 13;
              break;
            }
            return _context2.abrupt("return", true);
          case 13:
            return _context2.abrupt("return", Promise.reject('错误：' + message));
          case 14:
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", Promise.reject('异常：' + _context2.t0));
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 16]]);
    }));
    function resetPassword(_x3, _x4) {
      return _resetPassword2.apply(this, arguments);
    }
    return resetPassword;
  }(),
  renewMyPassword: function () {
    var _renewMyPassword2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref4, params) {
      var commit, dispatch, _yield$_renewMyPasswo, data, status, errCode, message;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref4.commit, dispatch = _ref4.dispatch;
            _context3.prev = 1;
            _context3.next = 4;
            return _renewMyPassword(params);
          case 4:
            _yield$_renewMyPasswo = _context3.sent;
            data = _yield$_renewMyPasswo.data;
            status = _yield$_renewMyPasswo.status;
            errCode = _yield$_renewMyPasswo.errCode;
            message = _yield$_renewMyPasswo.message;
            if (!(status === '0')) {
              _context3.next = 13;
              break;
            }
            return _context3.abrupt("return", data);
          case 13:
            return _context3.abrupt("return", Promise.reject('错误：' + message));
          case 14:
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", Promise.reject('异常：' + _context3.t0));
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 16]]);
    }));
    function renewMyPassword(_x5, _x6) {
      return _renewMyPassword2.apply(this, arguments);
    }
    return renewMyPassword;
  }(),
  loadAdminUsers: function () {
    var _loadAdminUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5, params) {
      var commit, _yield$getAdminUsers, data, status, message;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref5.commit;
            _context4.prev = 1;
            _context4.next = 4;
            return getAdminUsers(params);
          case 4:
            _yield$getAdminUsers = _context4.sent;
            data = _yield$getAdminUsers.data;
            status = _yield$getAdminUsers.status;
            message = _yield$getAdminUsers.message;
            if (!(status === '0')) {
              _context4.next = 13;
              break;
            }
            commit('SET_ADMIN_USERS', data);
            return _context4.abrupt("return", data);
          case 13:
            return _context4.abrupt("return", Promise.reject('错误：' + message));
          case 14:
            _context4.next = 19;
            break;
          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", Promise.reject('异常：' + _context4.t0));
          case 19:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 16]]);
    }));
    function loadAdminUsers(_x7, _x8) {
      return _loadAdminUsers.apply(this, arguments);
    }
    return loadAdminUsers;
  }(),
  getHammerAppFrameUrl: function () {
    var _getHammerAppFrameUrl = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref6) {
      var commit, state, _yield$adapi$getAdPro, props, _ref7, url;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref6.commit, state = _ref6.state;
            _context5.prev = 1;
            _context5.next = 4;
            return adapi.getAdProperties();
          case 4:
            _yield$adapi$getAdPro = _context5.sent;
            props = _yield$adapi$getAdPro.data;
            _ref7 = props.find(function (u) {
              return u.name === 'ad_dan_juan_hammer_app_h5_url_token';
            }) || {}, url = _ref7.value;
            if (url) {
              commit('app/HAMMER_H5_URL', url.replace('${token}', state.token), {
                root: true
              });
            }
            _context5.next = 13;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            console.log(_context5.t0);
          case 13:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 10]]);
    }));
    function getHammerAppFrameUrl(_x9) {
      return _getHammerAppFrameUrl.apply(this, arguments);
    }
    return getHammerAppFrameUrl;
  }(),
  // get user info
  getInfo: function getInfo(_ref8) {
    var commit = _ref8.commit,
      state = _ref8.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }

        // console.log('getInfo', data);

        // account: "admin"
        // companyId: null
        // createdOn: 1461830217000
        // employeeNum: null
        // id: 1
        // isActive: "1"
        // isBuildIn: null
        // isSuperuser: null
        // password: null
        // permissions:
        // roles:
        // updatedBy: null
        // updatedOn: null
        // userName: "admin"
        var id = data.id,
          roles = data.roles,
          account = data.account,
          userName = data.userName,
          permissions = data.permissions,
          isSuperuser = data.isSuperuser,
          callSystemAccount = data.callSystemAccount;

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_USERID', id);
        commit('SET_ROLES', roles);
        commit('SET_PERMISSIONS', permissions || []);
        commit('SET_NAME', userName);
        commit('SET_ACCOUNT', account);
        commit('IS_SUPER_USER', isSuperuser);
        commit('SET_CALL_SYSTEM_ACCOUNT', callSystemAccount);
        // commit('SET_AVATAR', avatar);
        // commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref9) {
    var commit = _ref9.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref10, role) {
    var commit = _ref10.commit,
      dispatch = _ref10.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context6.next = 5;
              return dispatch('getInfo');
            case 5:
              _yield$dispatch = _context6.sent;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context6.next = 10;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 10:
              accessRoutes = _context6.sent;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x10) {
        return _ref11.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};